import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">&#x24B8; 2023 create by marcin</p>
    </footer>
  );
};

export default Footer;
